
import { defineComponent, onMounted, ref, toRef, computed } from "vue";

import { getIllustrationsPath } from "@/core/helpers/assets";
import { UserInfoRequest } from "@/core/endpoints/requests/userInfo_request";
import OfferedCourses from "@/views/CourseEarlyRegistration/OfferedCourses.vue";
import Sections from "@/views/CourseEarlyRegistration/Sections.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentInstance } from "vue";
import { RegisteredCoursesRequest } from "@/core/endpoints/requests/earlyregisteredCourses_request";
import { RegisteredCoursesResponse } from "@/core/endpoints/responses/registeredCourses_response";
import UserData from "@/views/CourseEarlyRegistration/StudentData.vue";
import { useI18n } from "vue-i18n/index";
import { useStore } from "vuex";

export default defineComponent({
  name: "UserInfo",
  emits: ["emitloadSection"],
  components: {
    OfferedCourses,
    Sections,
    UserData,
  },
  props: {
    widgetClasses: String,
    semesterID: String,
    Course: Object,
  },
  setup(props) {
    const tabs = [
      {
        labelKey: "EarlyOfferedCourses",
        name: "Earlydashboard",
      },
      {
        labelKey: "EarlyRegisteredCourses",
        name: "EarlyregisteredCourses",
      },
      // {
      //   labelKey: "EarlyFees",
      //   name: "EarlycourseRegistrationFees",
      // },
      // {
      //   labelKey: "EarlyLog",
      //   name: "EarlycourseRegistrationLog",
      // },
    ];
    const { t, te } = useI18n();
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };
    onMounted(() => {
      setCurrentPageTitle(translate("CourseRegistration"));
    });
    let registeredCoursesRequest = new RegisteredCoursesRequest();

    let activeName = "Earlydashboard";
    const store = useStore();

    const errorMessage = computed(() => store.getters.getErrorMessage);
    //console.log(errorMessage);
    //console.log(errorMessage);

    const errMsg = ref();
    errMsg.value = errorMessage.value;

    if (errorMessage.value) {
      errMsg.value = errorMessage.value;
    }
    // let handleErrorMsg = () => {
    //   errMsg.value= errorMessage.value

    // };
    // setTimeout(handleErrorMsg, 1000);

    // let showAlertLoginValue = ref(
    //   localStorage.getItem("showAlertLogin") || "false"
    // );
    // let showAlertLogin = ref(
    //   showAlertLoginValue.value == "true" || showAlertLoginValue.value == "true"
    // );

    let showAlertLogin = ref("");
    let showAlertLoginValue = localStorage.getItem("showAlertLoginmsg");
    localStorage.removeItem("showAlertLoginmsg");
    localStorage.removeItem("showAlertLogin");
    if (showAlertLoginValue) {
      showAlertLogin.value = showAlertLoginValue;
    }

    const app = getCurrentInstance();
    let userInfoRequest = new UserInfoRequest();
    let details = ref<[]>();
    let courseId = ref(Number);
    let sceduleId = ref(Number);
    let enT_COURSE_PKG_DTL_ID = ref(Number);
    let edStudCourseRegId = ref(Number);
    let isReplace = ref(Boolean);

    let scscheduleDtlId = ref(Number);
    let semesterId = "";

    userInfoRequest.StudFacultyCode = JSON.parse(
      localStorage.getItem("user") || ""
    ).studFacultyCode;

    const setSemesterId = (semesterID) => {
      semesterId = semesterID;
    };
    const emitloadSection = (course) => {
      // debugger;
      details.value = [];

      if (semesterId != "") {
        registeredCoursesRequest.EdCourseId = course.eD_COURSE_ID;
        registeredCoursesRequest.EdStudSemesterId = semesterId;
        registeredCoursesRequest.invokeGetSelectCourseSection(
          app,
          (me: any, registeredCoursesResponse: RegisteredCoursesResponse) => {
            if (registeredCoursesResponse) {
              let res: any = {};
              res = registeredCoursesResponse;
              details.value = res.selectedCourseSections;
              courseId.value = course.eD_COURSE_ID;
              sceduleId.value = course.eD_COURSE_ID;
              enT_COURSE_PKG_DTL_ID.value = course.enT_COURSE_PKG_DTL_ID;
              edStudCourseRegId.value = course.edStudCourseRegId;
              scscheduleDtlId.value = course.scScheduleDtlId
                ? course.scScheduleDtlId
                : course.scscheduleDtlId;
              isReplace.value = course.isReplace;
            }
          }
        );
      }
    };
    return {
      getIllustrationsPath,
      activeName,
      emitloadSection,
      details,
      courseId,
      sceduleId,
      enT_COURSE_PKG_DTL_ID,
      setSemesterId,
      edStudCourseRegId,
      scscheduleDtlId,
      isReplace,
      tabs,
      showAlertLogin,
      errMsg,
      errorMessage,
    };
  },
});
